export default __webpack_public_path__ + "static/media/logo-deposito.5c95fd68.png";